export default class ErrorUtils {
  static handleAjaxError (error, endpoint, $router) {
    ErrorUtils.handleError('ajax', error, endpoint, $router);
  }

  static handleLoadError (error, endpoint, $router, $bus) {
    ErrorUtils.handleError('load', error, endpoint, $router);

    $bus.$emit('confirm-display', {
      title: window.bookero.translations.$t('errors.loadError.title'),
      desc: window.bookero.translations.$t('errors.loadError.desc'),
      okLabel: window.bookero.translations.$t('errors.loadError.refresh'),
      okClick: () => {
        window.location.reload();
      },
      hideOnRouteChange: true
    });
  }

  static handleSubmitError (error, endpoint, $router, $bus, callback) {
    if (error.response && error.response.status && error.response.status === 422) {
      ErrorUtils.handleError('format', error, endpoint, $router);
    } else if (error.response && error.response.status && error.response.status === 403) {
      ErrorUtils.handleError('submit', error, endpoint, $router);

      $bus.$emit('alert-display', {
        title: window.bookero.translations.$t('errors.operationError.titleNoPermissions'),
        desc: window.bookero.translations.$t('errors.operationError.descNoPermissions'),
        okLabel: window.bookero.translations.$t('errors.operationError.backToDashboard'),
        okClick: () => {
          window.bookero.openDashboard();
        }
      });
    } else {
      ErrorUtils.handleError('submit', error, endpoint, $router);

      $bus.$emit('confirm-display', {
        title: window.bookero.translations.$t('errors.operationError.title'),
        desc: window.bookero.translations.$t('errors.operationError.desc'),
        okLabel: window.bookero.translations.$t('errors.operationError.repeat'),
        okClick: () => {
          callback();
        }
      });
    }
  }

  static handleValidationError (error, endpoint, $router, $bus) {
    if (!ErrorUtils.isValidationError(error)) {
      return false;
    }

    ErrorUtils.handleError('format', error, endpoint, $router);

    $bus.$emit('notification-display', {
      message: ErrorUtils.getValidationErrorsMessage(error),
      type: 'error'
    });

    return true;
  }

  static isValidationError (error) {
    return !!(error && error.response && error.response.status === 422 && error.response.data && error.response.data.errors);
  }

  static getValidationErrorsMessage (error) {
    let errors = error.response.data.errors;
    let messages = [];

    for (let key of Object.keys(errors)) {
      messages = messages.concat(errors[key]);
    }

    return messages.join('. ');
  }

  static handleSubmitErrorWithoutCallback (error, endpoint, $router, $bus) {
    if (error.response && error.response.status && error.response.status === 422) {
      ErrorUtils.handleError('format', error, endpoint, $router);
    } else {
      ErrorUtils.handleError('submit', error, endpoint, $router);

      $bus.$emit('alert-display', {
        title: window.bookero.translations.$t('errors.operationErrorWithoutCallback.title'),
        desc: window.bookero.translations.$t('errors.operationErrorWithoutCallback.desc')
      });
    }
  }

  static handleError (type, error, endpoint, $router) {
    if (ErrorUtils.isInvalidToken(error)) {
      if (
        $router.currentRoute.path.indexOf('/login') === -1 &&
        $router.currentRoute.path.indexOf('/password/reminder') === -1 &&
        $router.currentRoute.path.indexOf('/password/reset') === -1 &&
        $router.currentRoute.path.indexOf('/register') === -1
      ) {
        $router.push('/login');
      }
    } else {
      ErrorUtils.reportError(type, error, endpoint);
    }
  }

  static reportError (type, error, endpoint) {
    console.log(error);
    let errorPrefix = '';

    switch (type) {
      case 'ajax': errorPrefix = '[Not handled] Endpoint error: '; break;
      case 'chunk': errorPrefix = '[Handled] '; break;
      case 'load': errorPrefix = '[Handled] Load error: '; break;
      case 'submit': errorPrefix = '[Handled] Submit error: '; break;
      case 'format': errorPrefix = '[Handled] 422 error: '; break;
    }

    if (window.bugsnagClient) {
      let ignoredEndpoints = [
        '/panel/notifications/get-notifications',
        '/panel/stats/stats-dashboard-inquiries-count',
        '/panel/dashboard/waiting-queries'
      ];

      if (ignoredEndpoints.indexOf(endpoint) === -1) {
        let metaData = ErrorUtils.prepareErrorMetaData(error);

        window.bugsnagClient.notify(new Error(errorPrefix + endpoint), event => {
          event.addMetadata('response', metaData);
        });
      }
    }
  }

  static isInvalidToken (error) {
    let tokenErrors = [400, 401, 500, 404];
    return error.response && error.response.status && tokenErrors.indexOf(error.response.status) > -1;
  }

  static prepareErrorMetaData (error) {
    let status = '-';
    let statusText = '-';

    if (error && error.response) {
      if (error.response.status) {
        status = error.response.status;
      }

      if (error.response.statusText) {
        statusText = error.response.statusText;
      }
    }

    return {
      'status': status,
      'statusText': statusText
    };
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/ErrorUtils.js